<script>
import '@/assets/css/cpr.css'

export default {
  name: 'CprHeader',
}
</script>

<template>
  <div class="cpr">
    <router-link to="/cpr">
      <div class="logo_wrap">
        <img src="@/assets/img/common/lexcode_logo.png" />
      </div>
      <h1>CPR 기사문 한영 번역 및 감수</h1>
    </router-link>
  </div>
</template>